module.exports = __webpack_public_path__ + "img/4c0ac0cbfed43619b45f86f9ddf9f632.eb959046.png";